import { lazy } from 'react';
import { hasPermission } from '@/utils/helpers';

const PermissionDeniedPage = lazy(() => import('@/pages/permission-denied'));

/**
 * Renders children only when the user has the required backend permission.
 * - requiredPermission: { subject, action } - if set, user must have this permission.
 * If not allowed, shows PermissionDeniedPage.
 */
export const PermissionRouteGuard = ({ requiredPermission, children }) => {
  if (!requiredPermission?.subject || !requiredPermission?.action) {
    return children;
  }
  const allowed = hasPermission({
    subject: requiredPermission.subject,
    action: requiredPermission.action,
  });
  if (!allowed) {
    return <PermissionDeniedPage />;
  }
  return children;
};

export default PermissionRouteGuard;
